
import { UseFormReturn } from "react-hook-form";
import { ProfileFormData } from "../../types";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { COUNTRIES } from '@/lib/constants';
import { Loader2 } from "lucide-react";

interface NationalityFieldProps {
  form: UseFormReturn<ProfileFormData>;
}

export const NationalityField = ({ form }: NationalityFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="nationality"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Nationality</FormLabel>
          <Select 
            value={field.value || ''} 
            onValueChange={field.onChange}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select your nationality" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {COUNTRIES.map((country) => (
                <SelectItem key={country.code} value={country.code}>
                  {country.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
